export default __webpack_public_path__ + "static/media/key-feature-manage-data.4b046150.mp4";